<template>
  <!-- 综合查询 -->
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <el-container
      style="border-top: 1px solid #dcdfe6; overflow: hidden; flex: 1"
    >
      <el-aside
        width="200px"
        style="
          border-right: 1px solid #dcdfe6;
          overflow: hidden;
          display: flex;
          flex-flow: column;
        "
      >
        <!-- 表格 -->
        <mytable
          :tableHeigth="tableHeigth"
          :tableData="tableData"
          :myTableHeard="myTableHeard"
          :isShowOperate="isShowOperate"
          :isselection="false"
          :isShowMoreOperate="isShowMoreOperate"
          :btnsList="btnsList"
          :fieldList="fieldList"
          :btnsMoreList="btnsMoreList"
          :Operatewidth="0"
          :showFilter="false"
          style="flex: 1"
          @fildsClick="fildsClick"
          :isindex="false"
          :showSummary="false"
        ></mytable>
        <!-- <paging
          ref="pags"
          :pageNum="pageStart"
          :total="pageCount"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          layout="prev, pager, next, total"
        ></paging> -->
        <el-pagination
          small
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageStart"
          :page-size="pageTotal"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageCount"
        >
        </el-pagination>
      </el-aside>
      <el-main
        style="overflow: hidden; padding: 10px 0px 0px 10px; overflow: hidden"
      >
        <el-tabs v-model="activeName" class="gen-zong-tab" type="border-card">
          <el-tab-pane label="运单信息" name="info" v-if="hasPermiss('admin:waibill:zonghechaxun:info')">
            <span slot="label">运单信息<i class="tab-fresh el-icon-refresh" v-if="activeName == 'info'" @click.stop="refresh('info')"></i></span>
            <base-info :waybillSplitId="selectedId" v-if="activeName == 'info'"></base-info>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="logs" style="height: 100%" v-if="hasPermiss('admin:waibill:zonghechaxun:logs')">
            <span slot="label">操作日志<i class="tab-fresh el-icon-refresh" v-if="activeName == 'logs'" @click.stop="refresh('logs')"></i></span>
            <operation-log :waybillSplitId="selectedId" v-if="activeName == 'logs'"></operation-log>
          </el-tab-pane>
          <el-tab-pane label="财务信息" name="finance" v-if="hasPermiss('aaaaa')">
            <span slot="label">财务信息<i class="tab-fresh el-icon-refresh" v-if="activeName == 'finance'" @click.stop="refresh('finance')"></i></span>
            <finance :waybillSplitId="selectedId" v-if="activeName == 'finance'"></finance>
          </el-tab-pane>
          <el-tab-pane label="附件" name="file" v-if="hasPermiss('aaaaa')">
            <span slot="label">附件<i class="tab-fresh el-icon-refresh" v-if="activeName == 'file'" @click.stop="refresh('file')"></i></span>
            <file :waybillSplitId="selectedId" v-if="activeName == 'file'"></file>
          </el-tab-pane>
          <el-tab-pane label="出入库记录" name="inoutLogs" style="height: 100%" v-if="hasPermiss('admin:waibill:zonghechaxun:inout:logs')">
            <span slot="label">出入库记录<i class="tab-fresh el-icon-refresh" v-if="activeName == 'inoutLogs'" @click.stop="refresh('inoutLogs')"></i></span>
            <storeage-log :waybillSplitId="selectedId" v-if="activeName == 'inoutLogs'"></storeage-log>
          </el-tab-pane>
          <el-tab-pane label="运单轨迹" name="traceLogs" style="height: 100%" v-if="hasPermiss('admin:waibill:zonghechaxun:trace:logs')">
            <span slot="label">运单轨迹<i class="tab-fresh el-icon-refresh" v-if="activeName == 'traceLogs'" @click.stop="refresh('traceLogs')"></i></span>
            <trace-log :waybillSplitId="selectedId" :waybillNumber="selectedNumber" :waybillSplitNumber="selectedSplitNumber" v-if="activeName == 'traceLogs'"></trace-log>
          </el-tab-pane>
          <el-tab-pane label="跟踪录入" name="traceList" style="height: 100%" v-if="hasPermiss('admin:waibill:zonghechaxun:trace:list')">
            <span slot="label">跟踪录入<i class="tab-fresh el-icon-refresh" v-if="activeName == 'traceList'" @click.stop="refresh('traceList')"></i></span>
            <trace-check-in :waybillSplitId="selectedId" :waybillNumber="selectedNumber" :waybillSplitNumber="selectedSplitNumber" v-if="activeName == 'traceList'"></trace-check-in>
          </el-tab-pane>
          <el-tab-pane label="所有单据" name="bills" style="height: 100%" v-if="hasPermiss('admin:waibill:zonghechaxun:bills')">
            <span slot="label">所有单据<i class="tab-fresh el-icon-refresh" v-if="activeName == 'bills'" @click.stop="refresh('bills')"></i></span>
            <all-bills :waybillSplitId="selectedId" v-if="activeName == 'bills'"></all-bills>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js 
import BaseInfo from "./BaseInfo.vue";
import OperationLog from "./OperationLog.vue";
import StoreageLog from "./StoreageLog.vue";
import TraceLog from "./TraceLog.vue";
import TraceCheckIn from "./TraceCheckIn.vue";
import AllBills from "./AllBills.vue";
import Finance from './Finance.vue'
import File from './File.vue'
export default {
  mixins: [tableListNew, exportjs],
  components: {
    queryCondition,
    sorttable,
    paging,
    queryBtns,
    mytable,
    BaseInfo,
    OperationLog,
    StoreageLog,
    TraceLog,
    TraceCheckIn,
    AllBills,
    Finance,
    File
  },
  props:{
    waybillNumber:{

    },
    waybillSplitId:{},
    orderNumber:{}
  },
  data() {
    return {
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [

      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
      ],
      //需要单独点击的列字段名数组
      fieldList: ["waybillNumber"],
      Operatewidth: "220px", //操作列的列宽
      //=======================导出相关 结束 =======================

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "ComprehensiveQuerySumAll", //  页面标识
      reportFiledsNumber: "admin_waybill_sum_list_v5", // 动态 条件、表头
      activeName: this.defaultTab(),
      selectedId:'',
      selectedNumber:'',
      selectedSplitNumber:''
    };
  },
  updated() {},
  created() {},
  mounted() {},
  activated() {},

  watch: {
    waybillNumber:{
      handler(val){
        this.ready()
      }
    },
    waybillSplitId:{
      handler(val){
        this.ready()
      }
    }
  },
  methods: {
    refresh(tabName){
      const tempId = this.selectedId
      const tempNumber = this.selectedNumber
      const tempSplitNumber = this.selectedSplitNumber
      this.selectedId = null
      this.selectedNumber = null
      this.selectedSplitNumber = null
      this.$nextTick(() =>{
        this.selectedId = tempId
        this.selectedNumber = tempNumber
        this.selectedSplitNumber = tempSplitNumber
      })
    },
    defaultTab(){
      if(this.hasPermiss('admin:waibill:zonghechaxun:info')){
        return  'info'
      }
      if(this.hasPermiss('admin:waibill:zonghechaxun:logs')){
        return  'logs'
      }
      if(this.hasPermiss('admin:waibill:zonghechaxun:inout:logs')){
        return  'inoutLogs'
      }
      if(this.hasPermiss('admin:waibill:zonghechaxun:trace:logs')){
        return  'traceLogs'
      }
      if(this.hasPermiss('admin:waibill:zonghechaxun:trace:list')){
        return  'traceList'
      }
      if(this.hasPermiss('admin:waibill:zonghechaxun:bills')){
        return  'bills'
      }
      return 'info'
    },
    async ready(){
      if(this.waybillNumber){
        this.setCondition('waybillNumbers',this.waybillNumber)
        this.setCondition('startCreateTime')
        this.setCondition('endCreateTime')
        await this.getData()
        if(this.tableData.length > 0){
          this.fildsClick(this.tableData[0])
        }
        return
      }
      if(this.waybillSplitId){
        this.setCondition('waybillSplitId',this.waybillSplitId)
        this.setCondition('startCreateTime')
        this.setCondition('endCreateTime')
        await this.getData()
        if(this.tableData.length > 0){
          this.fildsClick(this.tableData[0])
        }
        return
      }
    },
    fildsClick(row){
      this.selectedId = row.waybillSplitId
      this.selectedNumber = row.waybillNumber
      this.selectedSplitNumber = row.documentNumber
    }
  },
};
</script>


<style scoped lang="less">
.container {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
.gen-zong-tab {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  /deep/ .el-tabs__content {
    flex: 1;
    overflow: auto;
    padding: 10px 0px 0px 10px;
    margin-top: 20px;
  }
  /deep/ .el-tabs__nav{
    width: 100%;
    display: flex;
    .el-tabs__item{
      flex: 1;
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f4f4f4;
      &.is-active{
        background: #ffffff;
      }
    }
  }
  .el-form-item {
    margin-bottom: 5px;
  }
}
.tab-fresh{
  margin-left: 10px;
  position: absolute;
  top: calc(50% - 7px);
}
</style>
